/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

export const LOGIN_ERROR_MESSAGES = {
  401: "Wrong credentials, try again",
  "Username length": "Username must be longer than 3 characters",
  "Pass length": "Password must be longer than 8 characters",
  default: "Something went wrong",
};

export const MAIN_ERROR_MESSAGES = {
  400: "Start date cannot be less than Business date",
  401: "Authorization error, try to reload the page",
  tokenExpired: "Session timed out",
  default: "Something went wrong",
};
